import axios from "axios";
import { api, headers } from "../../app/conf";
import { makeQuery } from "../../shared/helpers/commons";

export const getUsers = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/users?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });

export const postUsers = (data, token) =>
    axios({
        method: "post",
        url: `${api}/users`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: data
    });

export const putUsers = (data, token) =>
    axios({
        method: "put",
        url: `${api}/users/${data._id}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: data
    });
